import {
    HELPDESK_LISTING,
    USER_DROPDOWN,
    APPROVER_DROPDOWN,
    SAVE_USER_CONFIG,
    UPDATE_USER_CONFIG,
    GET_AUTOFILL_DATA,
    USER_CONFIG_STATUS,
    USE_CASES,
    USER_REQUEST,
    USER_REQUEST_LIST,
    APPROVAL_PENDING_LIST,
    REQUEST_BY_ID,
    APPROVAL,
    BACK_TO_MODIFICATION_REQUEST, BACK_TO_MODIFICATION_RESPONSE, REQUEST_FILTER,
    FINANCE_HIERARCHY_LISTING, BACK_TO_MODIFICATION_REQUEST_LIST, CSV_DOWNLOAD,
    MRF_NUMBER_BY_INVOICE_NUMBER
} from "./type";

const initalState = {
    helpdesklisting: [],
    userdropdown: [],
    approverdropdown: [],
    saveuserconfig: [],
    updateuserconfig: [],
    getautofilldata: [],
    userconfigstatus: [],
    useCasesList:[],
    saveUserRequest:[],
    requestList:[],
    approvalPendingRequest:[],
    requestByIdDetails:[],
    approvedResponse:[],
    modificationRequest:[],
    modificationResponse:[],
    filterData:[],
    helpdeskHierarchyListing:[],
    modificationRequestList:[],
    csvDownloadResponse:[],
    mrfNumberByInvoiceNumber:[]
};

const UserHelpdesk = (state = initalState, action) => {
    const {type, payload} = action;
    switch (type) {
        case HELPDESK_LISTING:
            return {
                ...state,
                helpdesklisting: payload
            };
        case USER_DROPDOWN:
            return {
                ...state,
                userdropdown: payload
            };
        case APPROVER_DROPDOWN:
            return {
                ...state,
                approverdropdown: payload
            };
        case SAVE_USER_CONFIG:
            return {
                ...state,
                saveuserconfig: payload
            };
        case UPDATE_USER_CONFIG:
            return {
                ...state,
                updateuserconfig: payload
            };
        case GET_AUTOFILL_DATA:
            return {
                ...state,
                getautofilldata: payload
            };
        case USER_CONFIG_STATUS:
            return {
                ...state,
                userconfigstatus: payload
            };
        case USE_CASES:
            return {
                ...state,
                useCasesList: payload
            };
        case USER_REQUEST:
            return {
                ...state,
                saveUserRequest: payload
            };
        case USER_REQUEST_LIST:
            return {
                ...state,
                requestList: payload
            };
        case APPROVAL_PENDING_LIST:
            return {
                ...state,
                approvalPendingRequest: payload
            };
        case REQUEST_BY_ID:
            return {
                ...state,
                requestByIdDetails: payload
            };
        case APPROVAL:
            return {
                ...state,
                approvedResponse: payload
            };
        case BACK_TO_MODIFICATION_REQUEST:
            return {
                ...state,
                modificationRequest: payload
            };
        case BACK_TO_MODIFICATION_RESPONSE:
            return {
                ...state,
                modificationResponse: payload
            };
        case REQUEST_FILTER:
            return {
                ...state,
                filterData: payload
            };
        case FINANCE_HIERARCHY_LISTING:
            return {
                ...state,
                helpdeskHierarchyListing: payload
            };
        case BACK_TO_MODIFICATION_REQUEST_LIST:
            return {
                ...state,
                modificationRequestList: payload
            };
        case CSV_DOWNLOAD:
            return {
                ...state,
                csvDownloadResponse: payload
            };
        case MRF_NUMBER_BY_INVOICE_NUMBER:
            return {
                ...state,
                mrfNumberByInvoiceNumber: payload
            };
        default:
            return {
                ...state,
            };
    }
};

export default UserHelpdesk;
